// extracted by mini-css-extract-plugin
export default {"Box":"selected-repository-pill-module__Box--q1ncB","Text":"selected-repository-pill-module__Text--MNl3S","Text_1":"selected-repository-pill-module__Text_1--egBjz"};